// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"ddee932a","274":"6360a648","418":"6593194b","650":"b2811456","806":"f6323bcd"}[chunkId] + ".chunk.css";
};